import {
	CLEAR_LOGIN_STATE,
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAILED,
	REFRESH_TOKEN_REQUEST,
	REFRESH_TOKEN_SUCCESS,
	REFRESH_TOKEN_ERROR,
	USER_INFO_REQUEST,
	USER_INFO_SUCCESS,
	USER_INFO_ERROR,
	GET_TOKEN_LOCALSTORAGE,
	LOGOUT,
} from './actions';
import api from '@/utils/api';
import router from '@/router/router';

const { http } = api.getInstance();
const AUTH_URL = '/auth';
const USER_URL = '/users';

const defaultState = () => ({
	twoAuthHash: null,
	isLoginLoading: '',
	token: localStorage.getItem(`token`) || null,
	isRefreshLoading: '',
	userInfo: '',
	isLoadingUserInfo: '',
	isDescryptingToken: '',
});

const state = defaultState();

const getters = {
	isLogged: (state) => !!state.token,
	twoAuthHash: (state) => state.twoAuthHash,
	isLoginLoading: (state) => state.isLoginLoading === 'loading',
	token: (state) => state.token,
	isRefreshLoading: (state) => state.isRefreshLoading === 'loading',
	userInfo: (state) => state.userInfo,
	isLoadingUserInfo: (state) => state.isLoadingUserInfo === 'loading',
	isDescryptingToken: (state) => state.isDescryptingToken === 'loading',
};

const mutations = {
	[CLEAR_LOGIN_STATE]: (state) => {
		localStorage.removeItem('token');
		localStorage.removeItem('last');
		Object.assign(state, defaultState());
	},
	[LOGIN_REQUEST]: (state) => {
		state.isLoginLoading = 'loading';
	},
	[LOGIN_SUCCESS]: (state, { data, isAdmin }) => {
		if (isAdmin) {
			localStorage.setItem(`token`, data.token);
			state.token = data.token;
		}

		state.twoAuthHash = data.hashCode;
		state.isLoginLoading = 'success';
	},
	[LOGIN_FAILED]: (state) => {
		state.twoAuthHash = null;
		state.isLoginLoading = 'error';
	},
	[REFRESH_TOKEN_REQUEST]: (state) => {
		state.isRefreshLoading = 'loading';
	},
	[REFRESH_TOKEN_SUCCESS]: (state, { newToken }) => {
		localStorage.setItem(`token`, newToken);
		state.token = newToken;
		state.isRefreshLoading = 'success';
	},
	[REFRESH_TOKEN_ERROR]: (state) => {
		state.token = null;
		state.isRefreshLoading = 'error';
	},
	[USER_INFO_REQUEST]: (state) => {
		state.userInfo = {};
		state.isLoadingUserInfo = 'loading';
	},
	[USER_INFO_SUCCESS]: (state, data) => {
		state.userInfo = data;
		state.isLoadingUserInfo = 'success';
	},
	[USER_INFO_ERROR]: (state) => {
		state.userInfo = {};
		state.isLoadingUserInfo = 'error';
	},
	[GET_TOKEN_LOCALSTORAGE]: async (state) => {
		const tokenFromStorage = localStorage.getItem('token');
		state.isDescryptingToken = 'loading';
		state.token = tokenFromStorage;
		http.defaults.headers.common.Authorization = `Bearer ${tokenFromStorage}`;

		setTimeout(() => {
			state.isDescryptingToken = 'success';
		}, 2000);
	},
	[LOGOUT]: (state) => {
		state.twoAuthHash = null;
		state.isLoginLoading = '';
		state.token = null;
		state.userInfo = {};
		state.isLoadingUserInfo = '';
		state.isDescryptingToken = '';
	},
};

const actions = {
	[LOGIN_REQUEST]({ commit }, { login, vm, timestamp }) {
		return new Promise((resolve, reject) => {
			commit(LOGIN_REQUEST);

			http.defaults.headers.common.timestamp = timestamp;

			http({
				method: 'post',
				url: `${AUTH_URL}/login`,
				data: login,
			})
				.then((response) => {
					if (response.data.token != undefined && response.data.token != null) {
						http.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;
						commit(LOGIN_SUCCESS, { data: response.data, isAdmin: true });
					} else {
						commit(LOGIN_SUCCESS, { data: response.data, isAdmin: false });
					}

					resolve(response);
				})
				.catch((error) => {
					commit(LOGIN_FAILED);
					localStorage.removeItem('token');
					vm.$toastr.e(error.response.data.message);
					reject(error);
				});
		});
	},
	[REFRESH_TOKEN_REQUEST]: async ({ commit }) => {
		return new Promise((resolve, reject) => {
			commit(REFRESH_TOKEN_REQUEST);
			const storedToken = localStorage.getItem('token');

			const body = {
				token: storedToken,
			};

			http({
				method: 'POST',
				url: `${AUTH_URL}/refresh-token`,
				data: body,
			})
				.then((response) => {
					http.defaults.headers.common.Authorization = `Bearer ${response.data.newToken}`;
					commit(REFRESH_TOKEN_SUCCESS, response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
					commit(REFRESH_TOKEN_ERROR);
				});
		});
	},
	[USER_INFO_REQUEST]: async ({ commit }) => {
		return new Promise((resolve, reject) => {
			commit(USER_INFO_REQUEST);

			http({
				method: 'GET',
				url: USER_URL,
			})
				.then((response) => {
					http.defaults.headers.common['Accept-Language'] = 'pt-br';
					commit(USER_INFO_SUCCESS, response.data);
					resolve(response);
				})
				.catch((error) => {
					if (error && error.response && error.response.data.statusCode == 404) {
						localStorage.removeItem('token');
						localStorage.removeItem('last');
						router.push('/login');
					}

					reject(error);
					commit(USER_INFO_ERROR);
				});
		});
	},
	[GET_TOKEN_LOCALSTORAGE]({ commit }) {
		commit(GET_TOKEN_LOCALSTORAGE);
	},
	[LOGOUT]({ commit }) {
		return new Promise((resolve, reject) => {
			http.auth = null;
			http.defaults.headers.common.Authorization = null;
			commit(LOGOUT);
			resolve();
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
